module.exports = __webpack_public_path__ + "static/media/cloud-moon-rain.28d8a080.svg";